import { getWithCache } from "@sinch/mfe-helper-react";
import { getMessageMediaApiUrlMiddleware } from "../config";
import { MmUserZod, type MmUserPartial } from "./types";

export const MMFetchUserURL = `${getMessageMediaApiUrlMiddleware()}/iam/v1/jwt/userinfo`;

export const getMmUser = (token: string) =>
  getWithCache(MMFetchUserURL, token, {
    useToken: true,
  }).then((data) => {
    const parsed = MmUserZod.safeParse(data);
    if (parsed.success) return parsed.data;
    const errorMessage = "Invalid response from userinfo";
    console.error(errorMessage, parsed.error);
    return data as MmUserPartial;
  });

export const getFeatures = (user?: MmUserPartial) => [
  ...(user?.account?.features || []),
  ...(user?.featureSet.features || []),
];

export const getName = (user?: MmUserPartial) =>
  `${user?.user.firstName || ""} ${user?.user.lastName || ""}`.trim();
